import React, { Fragment } from 'react';
import blogSingle from '../../assets/images/blog/blog-single.jpg';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs, H4, LI, P, UL } from '../../AbstractElements';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import BlogComments from './BlogComments';

const BlogSingleContain = () => {
  const location = useLocation();
  const BlogDetails = location.state.BlogDetails;
  console.log(BlogDetails)

  const styless = {
    backgroundImage: `url(${blogSingle})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'block',
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Blog Details" parent="Blog" title="Blog Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <div className="blog-single">
              <div className="blog-box blog-details">

                <Card>
                  <CardBody>

                    <div className='row'>
                      <div className='col-md-6'>
                        <img className="banner-wrraper img-fluid w-100 bg-img-cover"
                          src={BlogDetails.image}
                          alt='BlogImage'
                        />
                      </div>
                      <div className='col-md-6'>
                        <div className="blog-details">
                          <UL
                            attrUL={{
                              className: 'blog-social flex-row simple-list',
                            }}
                          >
                            <LI>{formatDate(BlogDetails.blog_date)}</LI>
                            <LI>
                              <i className="icofont icofont-user"></i>
                              <span>{BlogDetails.user_name} </span>
                            </LI>
                            <LI>
                              <i className="icofont icofont-thumbs-up"></i>
                              {'02'}
                              <span>{'Hits'}</span>
                            </LI>
                            <LI>
                              <i className="icofont icofont-ui-chat"></i>
                              {'598 Comments'}
                            </LI>
                          </UL>
                          <h2 className='mt-4 mb-3'>
                            {BlogDetails.title}
                          </h2>
                          <P>{BlogDetails.content}</P>
                        </div>
                      </div>

                      <div className='col-md-12'>
                        <div className="single-blog-content-top">
                          <P>
                            {BlogDetails.description}
                          </P>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
export default BlogSingleContain;
